import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { companyConfig } from "../config/company";
import "./Navbar.css";

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const location = useLocation();

  // Schließe das Menü beim Routenwechsel
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const toggleMenu = (): void => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src={require("../assets/logo_2.png")} alt={companyConfig.name} className="nav-logo-image" />
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={isOpen ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/ueber-uns" className="nav-link">
              Über uns
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/leistungen" className="nav-link">
              Leistungen
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/galerie" className="nav-link">
              Galerie
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/kontakt" className="nav-link">
              Kontakt
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
